<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~/helpers'

interface SkeletonProps {
  class?: HTMLAttributes['class']
}

const props = defineProps<SkeletonProps>()

defineOptions({ name: 'Skeleton' })
</script>

<template>
  <div :class="cn('animate-pulse rounded-md bg-soft-gray', props.class)" />
</template>
